import { Card, CardContent, Typography } from "@mui/material";
import type { ModalWorkOrder } from "@/shared/work-orders-modals/models/ModalWorkOrder";
import type { WorkOrder } from "@/pages/work-orders/models/WorkOrder";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import Grid2 from '@mui/material/Grid2';

export const WorkOrderCard = ({ workOrder }: { workOrder: ModalWorkOrder | WorkOrder }) => {
	return (
		<Card variant="outlined" style={{ margin: "10px 0" }}>
			<CardContent style={{ paddingTop: 12, paddingBottom: 12 }}>
				<Grid2 spacing={1}>
					<Grid2 size={{ xs: 12 }}>
						<Typography variant="h6">
							{workOrder.WorkOrderName} - {workOrder.Title}
						</Typography>
					</Grid2>
					<Grid2 size={{ xs: 6 }}>
						<Typography variant="body2">
							Asset: {workOrder.AssetName}
						</Typography>
					</Grid2>
					<Grid2 size={{ xs: 6 }}>
						<Typography variant="body2">
							Opened by: {workOrder.WorkOrderOpenedBy}
						</Typography>
					</Grid2>
					<Grid2 size={{ xs: 6 }}>
						<Typography variant="body2">
							Status: {workOrder.WorkOrderStatusCode}
						</Typography>
					</Grid2>
					<Grid2 size={{ xs: 6 }}>
						<Typography variant="body2">
							Opened: {workOrder.OpenTimestamp ? 
								(workOrder.OpenTimestamp instanceof Date ? 
									dxtToLocalServerTime(workOrder.OpenTimestamp, "MM/dd/yy HH:mm") : 
									workOrder.OpenTimestamp
								) : 
								"N/A"
							}
						</Typography>
					</Grid2>
				</Grid2>
			</CardContent>
		</Card>
	);
};
